import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export default autoGeneratedReducer<{ id: number; text: string }[]>([]);
